<!-- COMPONENTE DE DESCONEXIÓN -->
@if(!showSurvey){
<div class="overlay-background">
    <sas-disconnected [reason]="disconnected" [roomData]="roomData" [roomSchedule]="roomSchedule"
    (waitingtRoomPublisher)="setWaitingtRoomPublisher($event)" [invalidPassword]="invalidPassword"
    (authentication)="sendPassword($event)" (reConnect)="entryAgain($event)" [forcePublisherOff]="forcePublisherOff">
  </sas-disconnected>
  

</div>
}@else {
  <sas-survey></sas-survey>
}